/*
 * @Author: 卢靖康
 * @Date: 2019-10-31 17:55:50
 * @LastEditTime: 2022-11-08 11:16:06
 * @LastEditors: 卢靖康
 */
export default {
    首页:'Home Page',
    NBHX:'NBHX',
    关于华翔:'About NBHX',
    // 使命愿景:'Mission & Vision',
    荣誉奖项:'Honors & Awards',
    主要客户:'Key Clients',
    全球分布:'Global Network',
    合作伙伴:'Partners',
    联系我们:'Contact Us',
    廉洁合规:'Integrity Compliance',

    新闻资讯:'News Release',
    媒体报道:'Press Release',
    企业新闻:'NBHX News',
    行业动态:'Industry News',

    核心业务:'Core Business',
    装饰条:'Trims',
    内外饰件:'Interiors and Exteriors',
    车身金属件:'Metal Parts',
    车身电子:'Electronics',
    // 轻量化材料:'轻量化材料',
    // 新能源电池包:'新能源电池包',

    人力资源:'Human Resources',
    招贤纳士:'Join Us',
    人才发展:'Talent Development',

    投资者关系:'Investor Relations',
    股票信息:'Stock Information',
    最新公告:'Announcements',
    公司治理:'Corporate Governance',

    关注我们:'Follow Us',

    查看更多:'Read More',

    tel:'Tel',
    date:'Date',
    author:'Author',
    source:'Source',
    copyright:'Ningbo Huaxiang Group Co., Ltd. All rights reserved. Copyright2022'
}
